import HelpIcon from '@mui/icons-material/Help';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
export const FormTooltip = ({ tooltip = {}, sx, children }) => {
    const { html, text } = tooltip;
    if (!(html || text)) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(Box, { display: 'flex', alignItems: 'center' },
        children,
        React.createElement(Tooltip, { title: html ? (React.createElement(Typography, { component: 'div', dangerouslySetInnerHTML: { __html: html }, "data-test": 'tooltip-html' })) : (React.createElement(Typography, { "data-test": 'tooltip-text' }, text)), sx: Object.assign({ ml: 1 }, sx) },
            React.createElement(IconButton, { size: 'medium', "data-test": 'tooltip-button', "aria-label": 'Additional Information' },
                React.createElement(HelpIcon, { fontSize: 'medium' })))));
};
